import React from "react";
import { SocialIcon } from "react-social-icons";
import "./css/Footer.css";

function Footer() {
  const iconstyle = {
    backgroundColor: "",
    left: "0",
    bottom: "0",
    width: "100%",
  };
  return (
    <div className="footer" style={iconstyle}>
      <div className="footer-icon">
        <SocialIcon url="http://instagram.com/" />
      </div>
      <div className="footer-icon">
        <SocialIcon url="http://facebook.com/" />
      </div>
      <div className="footer-icon">
        <SocialIcon url="http://youtube.com/" />
      </div>
      <div className="footer-icon">
        <SocialIcon url="http://linkedin.com/" />
      </div>
    </div>
  );
}

export default Footer;
